import { RequestContext, XcoreCore } from "@robe/core";
import { useMemo } from "react";
import { useRequestContext } from "./useRequestContext";

export const useXcoreCore = (ctxConfig?: RequestContext) => {
  const ctx = useRequestContext();
  return useMemo(() => new XcoreCore(ctxConfig ?? ctx), [ctx, ctxConfig]);
};
